<nav class="navbar category-nav-bar p-0 ">
  <div class="container">

    @if (isMyShopVisible) {
      @if (isAuthenticated == true) {
        @if (mediaBreakpoint >= eMediaBreakpoint.LG) {
          <app-my-shop-toggle-button></app-my-shop-toggle-button>
        }
      }
    }

    @if (isCategoryNavBarVisible) {
      @for (categoryTreeItem of categoryTreeItemList; track categoryTreeItem; let first = $first; let last = $last) {
        <span class="nav-item d-flex flex-column align-items-center text-center c-pointer m-0 p-3"
          [class.ms-auto]="first" [class.me-auto]="last && isAuthenticated == false" [routerLink]="['/product/list']"
          [queryParams]="{ categoryKey: categoryTreeItem.key }" target="_top"
          [class.active-underline]="activeCategory != undefined && categoryTreeItem.key?.localeCompare(activeCategory) == 0">
          <span>{{ categoryTreeItem.description }}</span>
        </span>
      }
    }

    @if (isCategoryNavBarVisible) {
      @if (isAuthenticated == true) {
        <span class="nav-item d-flex flex-column align-items-center text-center c-pointer ms-0 me-auto p-3"
          [routerLink]="['/product', 'promo']" target="_top"
          [class.active-underline]="activeCategory != undefined && activeCategory.indexOf('/product/promo') >= 0">
          <span i18n="@@CategoryNavBarPromo">Promos</span>
        </span>
      }
    }

  </div>
</nav>